const AMBIENT_HEARTS = ["🩷", "🩵", "🩷", "🩵", "🩷", "🩵", "🩷", "🩵", "🩷", "🩵", "🩷", "🩵", "🩷", "🩵", "🩷", "🩵"] as const;

export function AmbientHearts() {
  return <div className="ambient-hearts" aria-hidden="true">
    {AMBIENT_HEARTS.map((heart, index) => <span key={`${heart}-${index}`}>{heart}</span>)}
  </div>;
}

export function SceneEffects({ active, finale, line }: { active: boolean; finale?: boolean; line: string }) {
  return <div className={`scene-effect ${active ? "scene-effect--active" : ""} ${finale ? "scene-effect--finale" : ""}`} aria-hidden={!active}>
    <p>{line}</p><span>♥</span><span>✦</span><span>♥</span><span>✧</span><span>♥</span>
  </div>;
}
